"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _FormattedReactMessage = _interopRequireDefault(require("I18n/components/FormattedReactMessage"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedNumber = _interopRequireDefault(require("I18n/components/FormattedNumber"));

var _FormattedCurrency = _interopRequireDefault(require("I18n/components/FormattedCurrency"));

var _urls = require("pricing-pages-unified-ui/utils/urls");

var Editions = _interopRequireWildcard(require("self-service-api/constants/Editions"));

var _CurrencySelectors = require("pricing-pages-unified-ui/selectors/CurrencySelectors");

var _MerchandiseSelectors = require("pricing-pages-unified-ui/selectors/MerchandiseSelectors");

var _PricingSelectors = require("pricing-pages-unified-ui/selectors/PricingSelectors");

var SubtextMC = function SubtextMC(_ref) {
  var _editionLangMap;

  var handleLinkClick = _ref.handleLinkClick,
      edition = _ref.edition,
      merchandiseId = _ref.merchandiseId,
      priceTiers = _ref.priceTiers,
      termId = _ref.termId;
  var productsAndServicesUrl = (0, _urls.getProductsAndServicesCatalogUrl)();
  var currencyCode = (0, _reactRedux.useSelector)(_CurrencySelectors.activeCurrencySelector);
  var merchMap = (0, _reactRedux.useSelector)(_MerchandiseSelectors.merchandiseSelector);
  var baseMarketingMerch = (0, _reactRedux.useSelector)(function (state) {
    return (0, _MerchandiseSelectors.baseMerchForAdditionalUnitSelector)(state, merchandiseId);
  });
  var quantityMultiplier = merchMap[merchandiseId].quantityMultiplier;
  var includedAdditionalUnits = baseMarketingMerch.includedAdditionalUnits;
  var tier1Price = priceTiers[0].value;
  var tier1Band = (priceTiers[0].upperBound - priceTiers[0].lowerBound) * quantityMultiplier;
  var tier2Price = priceTiers[1].value;
  var tier2Amount = quantityMultiplier;
  var totalPrice = (0, _reactRedux.useSelector)(function (state) {
    return (0, _PricingSelectors.calculatedPriceSelector)(state, {
      merchandiseId: merchandiseId,
      termId: termId,
      itemConfigurations: [{
        merchandiseId: merchandiseId,
        quantity: tier1Band + tier2Amount
      }]
    });
  }).monthly.calculatedPrice;
  var editionLangMap = (_editionLangMap = {}, (0, _defineProperty2.default)(_editionLangMap, Editions.STARTER, 'contactTierPricingModal.marketingContacts.starterContacts'), (0, _defineProperty2.default)(_editionLangMap, Editions.PROFESSIONAL, 'contactTierPricingModal.marketingContacts.professionalContacts'), (0, _defineProperty2.default)(_editionLangMap, Editions.ENTERPRISE, 'contactTierPricingModal.marketingContacts.enterpriseContacts'), _editionLangMap);
  return _react.default.createElement("div", {
    className: "text-left"
  }, _react.default.createElement("p", null, _react.default.createElement(_Small.default, {
    use: "help"
  }, _react.default.createElement(_FormattedJSXMessage.default, {
    message: "contactTierPricingModal.marketingContacts.priceDisclaimer_jsx",
    elements: {
      LegalLink: function LegalLink(_ref2) {
        var children = _ref2.children;
        return _react.default.createElement(_UILink.default, {
          external: true,
          href: productsAndServicesUrl,
          style: {
            whiteSpace: 'nowrap'
          },
          onClick: handleLinkClick("marketing-" + edition + "-contacts-subtext1", productsAndServicesUrl)
        }, children);
      }
    }
  }))), _react.default.createElement("p", null, _react.default.createElement(_Small.default, {
    use: "help"
  }, _react.default.createElement(_FormattedReactMessage.default, {
    message: "contactTierPricingModal.marketingContacts.contactBillingRate",
    options: {
      quantity: _react.default.createElement(_FormattedNumber.default, {
        value: quantityMultiplier
      })
    }
  }))), _react.default.createElement("p", {
    className: "p-left-8"
  }, _react.default.createElement(_Small.default, {
    use: "help"
  }, _react.default.createElement(_FormattedReactMessage.default, {
    message: "contactTierPricingModal.marketingContacts.contactPricingExample",
    options: {
      exampleAmount: _react.default.createElement(_FormattedNumber.default, {
        value: includedAdditionalUnits + tier1Band + tier2Amount
      }),
      includedAdditionalUnits: _react.default.createElement(_FormattedNumber.default, {
        value: includedAdditionalUnits
      }),
      tier1Price: _react.default.createElement(_FormattedCurrency.default, {
        value: tier1Price,
        currencyCode: currencyCode,
        stripInsignificantZeros: true
      }),
      quantityMultiplier: _react.default.createElement(_FormattedNumber.default, {
        value: quantityMultiplier
      }),
      tier1Band: _react.default.createElement(_FormattedNumber.default, {
        value: tier1Band
      }),
      tier2Price: _react.default.createElement(_FormattedCurrency.default, {
        value: tier2Price,
        currencyCode: currencyCode,
        stripInsignificantZeros: true
      }),
      tier2Amount: _react.default.createElement(_FormattedNumber.default, {
        value: tier2Amount
      }),
      totalPrice: _react.default.createElement(_FormattedCurrency.default, {
        value: totalPrice,
        currencyCode: currencyCode,
        stripInsignificantZeros: true
      })
    }
  }))), _react.default.createElement("p", null, _react.default.createElement(_Small.default, {
    use: "help"
  }, _react.default.createElement(_FormattedJSXMessage.default, {
    message: "contactTierPricingModal.marketingContacts.priceDisclaimer2_jsx",
    elements: {
      MarketingVersion: function MarketingVersion() {
        return _react.default.createElement(_FormattedMessage.default, {
          message: editionLangMap[edition]
        });
      },
      LegalLink: function LegalLink(_ref3) {
        var children = _ref3.children;
        return _react.default.createElement(_UILink.default, {
          external: true,
          href: productsAndServicesUrl,
          onClick: handleLinkClick("marketing-" + edition + "-contacts-subtext2", productsAndServicesUrl)
        }, children);
      }
    }
  }))));
};

var _default = SubtextMC;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/common/contacts-price-breakdown/SubtextMC.js
// module id = 683
// module chunks = 5 6